Utils.prototype.emojies = {
    MOBC: {
        ":'(": 'cry.png#32',
        ';(': 'cry.png#32',
        ';-(': 'cry.png#32',

        ":')": 'joy.png#32',
        '.joy': 'joy.png#32',
        ':")': 'joy.png#32',

        '(:': 'reversed.png#32',
        '(d': 'reversed.png#32',

        '.)': 'smile.png#32',
        ':)': 'smile.png#32',
        ':-)': 'smile.png#32',
        ':=': 'smile.png#32',

        '.grr': 'grrr.png#32',
        '.grrr': 'grrr.png#32',
        '.grrrr': 'grrr.png#32',

        ':$': 'shy.png#32',
        ':-$': 'shy.png#32',
        ':-s': 'shy.png#32',
        ':s': 'shy.png#32',

        '.facepalm': 'facepalm.png#32',
        '.fp': 'facepalm.png#32',

        '.sh': 'shhh.png#32',
        '.shhh': 'shhh.png#32',

        ':((': 'super-angry.png#32',
        ':-((': 'super-angry.png#32',

        ':-/': 'confused.png#32',
        ':-\\': 'confused.png#32',
        ':/': 'confused.png#32',
        ':\\': 'confused.png#32',

        ':*': 'kiss.png#32',
        ':-*': 'kiss.png#32',
        ':b': 'kiss.png#32',

        ':**': 'heart.png#32',
        ':-**': 'heart.png#32',
        '<3': 'heart2.png#32',

        ':(': 'sad.png#32',
        ':-(': 'sad.png#32',

        ':-p': 'tongue.png#32',
        ':p': 'tongue.png#32',
        ':u': 'tongue.png#32',

        ';-o': 'saywhat.png#32',
        ';-oo': 'saywhat.png#32',
        ';o': 'saywhat.png#32',
        ';oo': 'saywhat.png#32',
        ';ooo': 'saywhat.png#32',

        '>)': 'evil.png#32',
        '>-)': 'evil.png#32',
        '>-d': 'evil.png#32',
        '>:)': 'evil.png#32',
        '>:-)': 'evil.png#32',
        '>;)': 'evil.png#32',
        '>;-)': 'evil.png#32',
        '>d': 'evil.png#32',

        ':-o': 'surprise.png#32',
        ':o': 'surprise.png#32',

        ':oo': 'woow.png#32',
        ':ooo': 'woow.png#32',

        ':z': 'sleep1.png#32',
        ':zz': 'sleep2.png#32',
        ':zzz': 'sleep2.png#32',
        ':zzzz': 'sleep2.png#32',

        '>.<': 'ay-ay-ay.png#32',
        '><': 'ay-ay-ay.png#32',
        '>_<': 'ay-ay-ay.png#32',
        'x)': 'ay-ay-ay.png#32',

        ';)': 'wink.png#32',
        ';-)': 'wink.png#32',

        ';-d': 'happy-wink.png#32',
        ';d': 'happy-wink.png#32',

        ';dd': 'happy-wink3.png#32',

        'x-d': 'lol.png#32',
        xd: 'lol.png#32',

        ':-d': 'happy.png#32',
        ':d': 'happy.png#32',

        ':-x': 'silence.png#32',
        ':x': 'silence.png#32',

        ':h': 'hug1.png#32',
        ':hh': 'hug2.png#32',
        ':hhh': 'hug3.png#32',

        '.halo': 'halo.png#32',
        '.hmm': 'hmm.png#32',

        ';p': 'wink-tongue.png#32',
        '^p^': 'closed-wink-tongue.png#32',
        '-_-': 'wonder-smile.png#32',
        '-o-': 'wonder1.png#32',
        '.arghh': 'arghh.png#32',
        '.fight': 'fight.png#32',
        '.gl': 'gl.png#32',
        '.phew': 'phew.png#32',
        '.shh': 'shh1.png#32',
        '.stare': 'stare.png#32',
        '.swap': 'swap.png#32',
        '.woohoo': 'woohoo.png#32',
        '<d': 'love-smile.png#32',
        '<p': 'tongue-love.png#32',
        '<pp': 'tongue-love2.png#32',
        '>><<': 'angry.png#32',
        '>p<': 'worried-tongue.png#32',
        '^=^': 'closedeye-smile-blush.png#32',
        '^_^': 'closedeye-smile.png#32',
        'd:': 'what.png#32',
        'o.o': 'oooo.png#32',

        'b-)': 'favicon.png#32',

        ':))': 'super-happy.png#32',
        ':)))': 'super-happy-1.png#32',
        ':))))': 'super-happy-2.png#32',
        ':)))))': 'super-happy-3.png#32',
        ':))))))': 'super-happy-4.png#32',
        ':)))))))': 'super-happy-5.png#32',
        ':))))))))': 'super-happy-6.png#32',
        ':)))))))))': 'super-happy-7.png#32',
        ':))))))))))': 'super-happy-8.png#32',
        ':)))))))))))': 'super-happy-9.png#32',
        ':))))))))))))': 'super-happy-10.png#32',
        ':)))))))))))))': 'super-happy-11.png#32',
        ':))))))))))))))': 'super-happy-12.png#32',
        ':)))))))))))))))': 'super-happy-13.png#32',
        ':))))))))))))))))': 'super-happy-14.png#32',
        ':)))))))))))))))))': 'super-happy-15.png#32',
        ':))))))))))))))))))': 'super-happy-16.png#32',
        ':)))))))))))))))))))': 'super-happy-17.png#32',
        ':))))))))))))))))))))': 'super-happy-18.png#32',
        ':)))))))))))))))))))))': 'super-happy-19.png#32',
        ':))))))))))))))))))))))': 'super-happy-20.png#32',
        ':)))))))))))))))))))))))': 'super-happy-19.png#32',
        ':-))': 'super-happy.png#32',
        ':-)))': 'super-happy-1.png#32',
        ':-))))': 'super-happy-2.png#32',
        ':-)))))': 'super-happy-3.png#32',
        ':-))))))': 'super-happy-4.png#32',
        ':-)))))))': 'super-happy-5.png#32',
        ':-))))))))': 'super-happy-6.png#32',
        ':-)))))))))': 'super-happy-7.png#32',
        ':-))))))))))': 'super-happy-8.png#32',
        ':-)))))))))))': 'super-happy-9.png#32',
        ':-))))))))))))': 'super-happy-10.png#32',
        ':-)))))))))))))': 'super-happy-11.png#32',
        ':-))))))))))))))': 'super-happy-12.png#32',
        ':-)))))))))))))))': 'super-happy-13.png#32',
        ':-))))))))))))))))': 'super-happy-14.png#32',
        ':-)))))))))))))))))': 'super-happy-15.png#32',
        ':-))))))))))))))))))': 'super-happy-16.png#32',
        ':-)))))))))))))))))))': 'super-happy-17.png#32',
        ':-))))))))))))))))))))': 'super-happy-18.png#32',
        ':-)))))))))))))))))))))': 'super-happy-19.png#32',
        ':-))))))))))))))))))))))': 'super-happy-20.png#32',
        ':-)))))))))))))))))))))))': 'super-happy-19.png#32',
        'b)': 'super-happy-19.png#32',
        'd)': 'super-happy-19.png#32',
        bd: 'super-happy.png#32',
        '.bug': 'bug.png#32',
    },
    'Pls List': {
        '.jail': '../bot/jail.png',
        '.ok': '../bot/ok.png',
        '.baguette': '../bot/baguette.png',
        '.balloon': '../bot/balloon.png',
        '.censor': '../bot/censor.png',
        '.deny': '../bot/deny.png',
        '.fail': '../bot/fail.png',
        '.jail': '../bot/jail.png',
        '.lick': '../bot/lick.png',
        '.love': '../bot/love.png',
        '.marsh': '../bot/marshmallow.png',
        '.mask': '../bot/mask.png',
        '.ninibear': '../bot/ninibear.png',
        '.pie': '../bot/pie.png',
        '.pinky': '../bot/pinky.png',
        '.pipi': '../bot/pipi.png',
        '.poison': '../bot/poison.png',
        '.roast': '../bot/roast.png',
        '.saltbae': '../bot/saltbae.png',
        '.scam': '../bot/scam.png',
        '.shrug': '../bot/shrug.png',
        '.slap': '../bot/slap.png',
        '.troll': '../bot/troll.png',
        '.whip': '../bot/whip.png',
        '.joker': '../bot/joker.png',
        '.trophy': '../bot/trophy.png',
    },
    'Alphanumeric ': {
        '.0': 'alpha/0.png#32',
        '.1': 'alpha/1.png#32',
        '.2': 'alpha/2.png#32',
        '.3': 'alpha/3.png#32',
        '.4': 'alpha/4.png#32',
        '.5': 'alpha/5.png#32',
        '.6': 'alpha/6.png#32',
        '.7': 'alpha/7.png#32',
        '.8': 'alpha/8.png#32',
        '.9': 'alpha/9.png#32',
        '.a': 'alpha/a.png#32',
        '.b': 'alpha/b.png#32',
        '.c': 'alpha/c.png#32',
        '.d': 'alpha/d.png#32',
        '.e': 'alpha/e.png#32',
        '.f': 'alpha/f.png#32',
        '.g': 'alpha/g.png#32',
        '.h': 'alpha/h.png#32',
        '.i': 'alpha/i.png#32',
        '.j': 'alpha/j.png#32',
        '.k': 'alpha/k.png#32',
        '.l': 'alpha/l.png#32',
        '.m': 'alpha/m.png#32',
        '.n': 'alpha/n.png#32',
        '.o': 'alpha/o.png#32',
        '.p': 'alpha/p.png#32',
        '.q': 'alpha/q.png#32',
        '.r': 'alpha/r.png#32',
        '.s': 'alpha/s.png#32',
        '.t': 'alpha/t.png#32',
        '.u': 'alpha/u.png#32',
        '.v': 'alpha/v.png#32',
        '.w': 'alpha/w.png#32',
        '.x': 'alpha/x.png#32',
        '.y': 'alpha/y.png#32',
        '.z': 'alpha/z.png#32',
        '.ñ': 'alpha/%c3%b1.png#32',
    },
    Users: {
        // '.cy': 'goodluck.png#32',
        '.sd': 'sd2.gif#32',
        '.syd': 'syd.png#32',
        '.sydd': 'sydd.gif#32',
        '.sadniss': 'sydd.gif#32',
        '.sadxoxo': 'sydd.gif#32',
        '.sydd': 'sydd.gif#32',
        '.gato': 'gato.png#32',
        '.bg': 'gato.png#32',
        '.sp': 'sp.gif#32',
        ".n'joy": 'njoy.png#32',
        '.alien': 'alien.png#32',
        '.amralex': 'amralex.png#32',
        '.ana': 'banana.png#32',
        '.angel': 'angel.png#32',
        '.anis': 'anis.png#32',
        '.annie': 'annie.png#32',
        '.arose': 'arose.png#32',
        '.astrodaphne': 'astrodaphne.png#32',
        '.astrolove': 'astrolove.png#32',
        '.baby': 'baby.png#32',
        '.banana': 'banana.png#32',
        '.bank': 'bank.png#32',
        '.barbie': 'barbie.png#32',
        '.batman': 'batman.png#32',
        '.emrvld': 'emrvld.png#32',
        '.bait': 'bait3.gif#32',
        '.bdevil': 'black_devil.png#32',
        '.bender': 'bender.png#32',
        '.besitos': 'besitos.png',
        '.bittu': 'bittu.png#32',
        '.black': 'vish.png#32',
        '.black_devil': 'black_devil.png#32',
        '.blue': 'elefant.png#32',
        '.boo': 'ghost.png#32',
        '.booga': 'booga.png#32',
        '.boring': 'elefant.png#32',
        '.bot': 'bender.png#32',
        '.brad': 'brad1.png#32',
        '.brad24': 'brad24.png#32',
        '.bread': 'bread.png#32',
        '.broc': 'broccoli.png#32',
        '.broccoli': 'broccoli.png#32',
        '.bun': 'bunny.png#32',
        '.bunny': 'bunny.png#32',
        '.bxzprincessa': 'princess.png#32',
        '.cafe': 'coffee.png#32',
        '.call': 'call.png#32',
        '.candy': 'candyy.png#32',
        '.candyman': 'candyman.png#32',
        '.carrot': 'carrot3.gif#32',
        '.catjam': 'catjam.gif#32',
        '.captain': 'captain1.png#32',
        '.simp': 'simp.gif#32',
        '.cat': 'meaw.png#32',
        '.cheer': 'cheer.png#32',
        '.cher': 'potato.png#32',
        '.chewbaca': 'chewy.png#32',
        '.chewy': 'chewy.png#32',
        '.chou': 'chou1.png#32',
        '.clap': 'mouse.png#32',
        '.cman': 'candyman.png#32',
        '.cml': 'cml.png#32',
        '.coffee': 'coffee.png#32',
        '.cow': 'cow.png#32',
        '.cowboy': 'cowboy.png#32',
        '.croack': 'croack.png#32',
        '.croackie': 'croack.png#32',
        '.crown': 'crown.png#32',
        '.cry': 'pepe-cry.png#32',
        '.cuack': 'duck2.png#32',
        '.cute': 'worm.png#32',
        '.maeve': 'cutie2.png#32',
        '.daph': 'mom.png#32',
        '.ded': 'ded.gif#32',
        '.dev': 'dev.png#32',
        '.devil': 'evilt.png#32',
        '.df': 'df.png#32',
        '.die': 'die.png#32',
        '.dingall777': 'dingall777.png#32',
        '.dingle': 'dingle.png#32',
        '.dog': 'dog.png#32',
        '.glow': 'glow.png#32',
        '.tesd': 'tesd.png#32',
        '.donut': 'cher.png#32',
        '.dove': 'dove.png#32',
        '.dragon': 'dragonfly.png',
        '.dragonfly': 'dragonfly.png',
        '.dreamworld': 'strawberry.png#32',
        '.dreamworld2': 'dreamworld2.png#32',
        '.duck': 'duck2.png#32',
        '.e.e': 'marro.png#32',
        '.eagle': 'brad1.png#32',
        '.edu': 'kiddo.png#32',
        '.ee': 'marro.png#32',
        '.eggplant': 'eggplant.png#32',
        '.elefant': 'elefant.png#32',
        '.elena': 'elena.png#32',
        '.elephant': 'elefant.png#32',
        '.ellie': 'elefant.png#32',
        '.et': 'et.png#32',
        '.evil': 'evilt.png#32',
        '.fl': 'fox.png#32',
        '.flan': 'flan.png#32',
        '.flove': 'flove.png#32',
        '.fluff': 'fluff.png#32',
        '.fox': 'fox.png#32',
        '.foxy': 'foxy.png#32',
        '.foxylady': 'foxy.png#32',
        '.frog': 'croack.png#32',
        '.gator': 'gator.png#32',
        '.gerbera': 'gerbera.png#32',
        '.ghost': 'ghost.png#32',
        '.goat': 'goat.png#32',
        '.goric': 'goric.png#32',
        '.grandma': 'grandma.png#32',
        '.greenangel': 'greenangel.png#32',
        '.greenie': 'greenangel.png#32',
        '.gt': 'gt.png#32',
        '.gtgirl': 'gt.png#32',
        '.gubex': 'gubex.png#32',
        '.gud': 'gud.png#32',
        '.bad': 'bad.png#32',
        '.happy': 'dangyhappy2.png#32',
        '.heart': 'heart3.png#32',
        '.hun': 'loo.png#32',
        '.ibtesam': 'ibtesam.png#32',
        '.ij': 'ij.png#32',
        '.inlove': 'inlove.png#32',
        '.irish': 'shamrock.png#32',
        '.joker': 'joker.png#32',
        '.julie': 'julie.png#32',
        '.keighly': 'dangyhappy2.png#32',
        '.kevin': 'kevin.png#32',
        '.kiddo': 'kiddo.png#32',
        '.kilo': 'kilo.png#32',
        '.kittykiss': 'kittykiss.png#32',
        '.kk': 'kittykiss.png#32',
        '.koala': 'koala.png#32',
        '.ladysparty': 'michy.png#32',
        '.lam': 'lam.png#32',
        '.lame': 'lamie.png#32',
        '.lamie': 'lamie.png#32',
        '.lamr': 'lamr.png#32',
        '.lana': 'lana.png#32',
        '.lis': 'lis.gif#32',
        '.leafy': 'leafy.png#32',
        '.lilly': 'lilly.png#32',
        '.lily': 'lily.png#32',
        '.lit': 'litty.png#32',
        '.litty': 'litty.png#32',
        '.ll': 'looby2.png#32',
        '.loo': 'loo.png#32',
        '.looby': 'looby.png#32',
        '.looby2': 'looby2.png#32',
        '.loobyloo': 'looby.png#32',
        '.love': 'love.png#32',
        '.lovelie': 'lovelie.png#32',
        '.luna': 'shelly.png#32',
        '.lyra': 'lyra.png#32',
        '.marro': 'marro.png#32',
        '.mate': 'mate.png#32',
        '.matt': 'matt.png#32',
        '.mattheo': 'mattheo.png#32',
        '.me': 'baby.png#32',
        '.meaw': 'meaw.png#32',
        '.meow': 'meaw.png#32',
        '.mert': 'peach.png#32',
        '.metal': 'bender.png#32',
        '.michy': 'michy.png#32',
        '.mlove': 'mlove.png#32',
        '.mom': 'mom.png#32',
        '.moo': 'cow.png#32',
        '.mooo': 'cow.png#32',
        '.moooo': 'cow.png#32',
        '.mooooo': 'cow.png#32',
        '.mouse': 'mouse.png#32',
        '.muah': 'muah.png#32',
        '.mv': 'mv.png#32',
        '.myo': 'myo.png#32',
        '.myoho': 'myoho.png#32',
        '.naive': 'naive.png#32',
        '.nem': 'nem.png#32',
        '.nfl': 'nfl.png#32',
        '.ninja': 'ninja.png#32',
        '.nlt': 'nlt.png#32',
        '.noob': 'dingall777.png#32',
        '.oil': 'oil.png#32',
        '.p2': 'p1.png#32',
        '.panda': 'panda2.png#32',
        '.pardis': 'black_devil.png#32',
        '.patriot': 'patriot.png#32',
        '.paul': 'paul.png#32',
        '.paulineg': 'paulineg.png#32',
        '.peace': 'peace.png#32',
        '.peach': 'peach.png#32',
        '.pear': 'pear.png#32',
        '.pera': 'pear.png#32',
        '.pg': 'pg.png#32',
        '.pig': 'pig.png#32',
        '.plop': 'plop.png#32',
        '.poledance': 'njoy.png#32',
        '.popeye': 'sailor.png#32',
        '.potato': 'potato.png#32',
        '.princesa': 'princess.png#32',
        '.princess': 'princess.png#32',
        '.prinny': 'princess.png#32',
        '.pump': 'pump.png#32',
        '.pumpkin': 'pumpkin.png#32',
        '.puppy': 'puppy.png#32',
        '.purple': 'uneek.png#32',
        '.quack': 'duck2.png#32',
        '.queen': 'queen.png#32',
        '.rain': 'rainbow2.png#32',
        '.rainbow': 'rainbow.png#32',
        '.raninbowking': 'captain1.png#32',
        '.rat': 'mouse.png#32',
        '.rathug': 'rathug.png',
        '.rip': 'rip.png#32',
        '.rk': 'captain1.png#32',
        '.rana': 'rana.png#32',
        '.froghug': 'rana.png#32',
        '.ranahug': 'rana.png#32',
        '.robot': 'bender.png#32',
        '.rock': 'rock.png#32',
        '.ron': 'myoho.png#32',
        '.rose': 'rose2.png#32',
        '.roseeee': 'rose2.png#32',
        '.royal': 'royal.png#32',
        '.sailor': 'sailor.png#32',
        '.salt': 'cher.png#32',
        '.sb': 'strawberry.png#32',
        '.sbg': 'sbg.png#32',
        '.scream': 'scream.png#32',
        '.sf': 'sunflower.png#32',
        '.shamrock': 'shamrock.png#32',
        '.sheep': 'sheep.png#32',
        '.sheepy': 'sheep2.png#32',
        '.shelly': 'shelly.png#32',
        '.shem': 'shem.png#32',
        '.shiny': 'bender.png#32',
        '.silver': 'baby.png#32',
        '.skull': 'skull.png#32',
        '.slayer': 'slayer.png#32',
        '.sloth': 'sloth.png#32',
        '.snake': 'snake.png#32',
        '.sock': 'sock.png#32',
        '.sol': 'sun.png#32',
        '.son': 'dog.png#32',
        '.spice': 'spice.png#32',
        '.spiderman': 'spiderman.png#32',
        '.ssb': 'dreamworld2.png#32',
        '.strawberry': 'strawberry.png#32',

        '.sun': 'sun.png#32',
        '.sunflower': 'sunflower.png#32',
        '.sushi': 'sushi.png#32',
        '.suzze': 'suzze.png#32',
        '.swan': 'swan.png#32',
        '.sweet': 'sweet.png',
        '.sweets': 'sweet.png',
        '.tiger': 'tiger.png#32',
        '.tiks': 'tiks1.png#32',

        '.tomate': 'tomate.png#32',
        '.tomato': 'tomate.png#32',
        '.tornado': 'tornado.png#32',
        '.toro': 'toro.png#32',
        '.tuaha': 'tuaha.png#32',
        '.turk': 'turk.png#32',
        '.turtle': 'turtle.png#32',
        '.uneek': 'uneek.png#32',
        '.unholy': 'unholy.png#32',
        '.unmoon': 'unmoon.png#32',
        '.vampire': 'vampire.png#32',
        '.veronica': 'veronica.png#32',
        '.vish': 'vish.png#32',
        '.oof': 'ooof.png#32',
        ':-k': 'koala.png#32',
        ':-n': 'ninja.png#32',
        ':k': 'koala.png#32',
        ':n': 'ninja.png#32',
        '<33': 'heart2.png#32',
        '<333': 'heart4.png#32',
        '.wade': 'wade1.png#32',
        '.worm': 'worm.png#32',
        '.smiley': 'smiley.png#32',
        '.wow': 'smiley.png#32',
        '.lul': 'lul.png#32',
        '.cough2': 'cough2.png#32',
        '.cough3': 'cough3.png#32',
        '.high': 'high.png#32',
        '.radish': 'radish.png#32',
        '.alex': 'alex.png#32',
        '.kitsune': 'kitsune.png#32',
        '.skate': 'skate.png#32',
        '.dgt': 'dgt.png#32',
        '.breal': 'dgt.png#32',
        '.dsotk': 'dsotk.png#32',
        '.cringe': 'cringe.png#32',
        '.gvn': 'cringe.png#32',
        '.dingall': 'dingall.png#32',
        '.boredpa': 'boredpa.png',
        '.crazypa': 'crazypa.png',
        '.ayl': 'ayl.png#32',
        '.hyfrox': 'hyfrox.png#32',
        '.frox': 'hyfrox.png#32',
        '.rex': 'hyfrox.png#32',
        '.salvy': 'salvy.png',
        '.bl': 'bl.png#32',
        '.charlie': 'charlie2.png#32',
        '.ok': 'ok.png#32',
        '.lf': 'lf.png#32',
    },
    Animated: {
        '.alfred': 'alfred.gif',
        '.alien2': 'alien2.gif',
        '.amour': 'amour.gif',
        '.andrada': 'andrada.gif',
        '.b24': 'b24.gif',
        '.babychou': 'chou2.gif',
        '.bank8': 'bank8.gif',
        '.bittu2': 'bittu2.gif',
        '.br24': 'br24.gif',
        '.brad2': 'brad2.gif',
        '.bubbles': 'bubbles2.gif',
        '.captain2': 'captain.gif',
        '.cara': 'alien2.gif',
        '.cat2': 'cat.gif',
        '.charm': 'charm.gif',
        '.cheeses': 'cheeses.gif',
        '.chou2': 'chou2.gif',
        '.cf': 'cf.gif#32',
        '.cm2': 'cm.gif',
        '.connie': 'connie.gif',
        '.dandy': 'dandy.gif',
        '.daph2': 'daph.gif',
        '.darren': 'darren.gif',
        '.darren2': 'darren2.gif',
        '.demi': 'demi3.gif',
        '.df2': 'df4.gif',
        '.dh': 'dh.gif',
        '.die2': 'die2.gif',
        '.don': 'don.gif',
        '.drona': 'drona.gif',
        '.dull': 'dull.gif',
        '.dz': 'dz.gif',
        '.edu016': 'edu016.gif',
        '.elena2': 'elena.gif',
        '.emma': 'emma.gif',
        '.farty': 'farty.gif',
        '.foxy2': 'foxy4.gif',
        '.foxy3': 'foxy5.gif',
        '.ga': 'ga.gif',
        '.goric2': 'goric.gif',
        '.gt2': 'gt3.gif',
        '.halloween': 'halloween.gif',
        '.hamster': 'hamster.gif',
        '.hbk': 'hbk.gif',
        '.hbksugar': 'hbksugar.gif',
        '.heaven': 'heaven2.gif',
        '.hers': 'hers.gif',
        '.hibye': 'hibye.gif',
        '.his': 'his.gif',
        '.hug': 'hug.gif',
        '.hug2': 'hug2.gif',
        '.hugs': 'hug.gif',
        '.infa': 'infa.gif',
        '.januar': 'januar.gif',
        '.johnny': 'johnny.gif',
        '.kazz': 'kazz.gif',
        '.kazz2': 'kazz2.gif',
        '.lamr2': 'lamr2.gif',
        '.ld': 'ld.gif',
        '.hands': 's/handsinair.gif',
        '.party': 's/party.gif',
        '.disco': 's/discodancer.gif',
        '.ld1': 'ld2.gif',
        '.looby3': 'looby3.gif',
        '.looby4': 'looby11.gif',
        '.looby5': 'england.gif',
        '.looser': 'looser.gif',
        '.looser2': 'looser2.gif',
        '.lovers': 'lovers.gif',
        '.lp': 'lp.gif',
        '.marlee': 'marlee.gif',
        '.marro2': 'salty.gif',
        '.matt2': 'matt2.gif',
        '.mezo': 'mezo.gif',
        '.michy2': 'michy2.gif',
        '.mistique': 'mistique.gif',
        '.mm': 'mm.gif',
        '.mnbv': 'mnbv.gif',
        '.moosh': 'moosh.gif',
        '.mrworkout': 'mwo.gif',
        '.mvp': 'mvp2.gif',
        '.mwo': 'mwo.gif',
        '.mwo2': 'mwo2.gif',
        '.mz': 'mz2.gif',
        '.nadeem': 'nadeem.gif',
        '.nat': 'nat.gif',
        '.nep': 'nep.gif',
        '.nicole': 'nicole.gif',
        '.olly': 'olly.gif',
        '.pa': 'pardis.gif',
        '.pardis2': 'pardis.gif',
        '.paul2': 'paul2.gif',
        '.paul3': 'paul3.gif',
        '.pauline2': 'pauline2.gif',
        '.pauline3': 'pauline3.gif',
        '.queen2': 'queen2.gif',
        '.razi': 'razi2.gif',
        '.razz': 'razz.gif',
        '.ro': 'ro.gif',
        '.robo': 'robo.gif',
        '.robo1000': 'robo1000.gif',
        '.rose2': 'rose2.gif',
        '.rose3': 'rose6.gif',
        '.salty': 'salty.gif',
        '.sbg2': 'sbg.gif',
        '.sbg3': 'sbg3.gif',
        '.sbg4': 'sbg4.gif',
        '.sbg5': 'sarah.gif',
        '.selle': 'selle3.gif',
        '.shades': 'sgades2.gif',
        '.sharky': 'sharky.gif',
        '.shaw': 'shaw1.gif',
        '.shaw2': 'shaw2.gif',
        '.shelly2': 'shelly2.gif',
        '.shelly3': 'shelly3.gif',
        '.silver2': 'silver2.gif',
        '.sissy': 'sissy.gif',
        '.snp': 'saltnpepper.gif',
        '.sock2': 'sock.gif',
        '.spank': 'spank.gif',
        '.spice2': 'spice2.gif',
        '.squishy': 'squishy.gif',
        '.star': 'star.gif',

        '.suzzee': 'suzee3.gif',
        '.tao': 'tao.gif',
        '.tiks2': 'tiks2.gif',
        '.ttlqf': 'ttlqf.gif',
        '.vegito': 'vegito.gif',
        '.veronica2': 'veronica2.gif',
        '.vloodzy': 'vloodzy.gif',
        '.wade2': 'wade2.gif',
        '.wade3': 'wade3.gif',
        '.warning': 'warning.gif',
        '.wolfy': 'wolfy.gif',
        '.yorkie': 'yorkie.gif',
        '.zen': 'zen3.gif',
        '.zodiac': 'zodiac.gif',
        '.rose4': 'rose7.gif',
        '.rose5': 'rose8.gif',
        '.cough': 'cough.gif',
        '.wade5': 'wade5.gif',
        '.mp': 'mp.gif',
        '.florest': 'florest.gif',
        '.flo': 'florest.gif',
        '.fl0rest': 'florest.gif',
        '.flb': 'flb.gif',
        '.tigre': 'tigre.gif',
        '.elena3': 'elena3.gif',
        '.foxy4': 'foxy6.gif',
        '.hello': 'hello.gif',
        '.hello2': 'hello2.gif',
        '.hola': 'hola.gif',
        '.hallo': 'hola.gif',
        '.salut': 'hola.gif',
        '.ola': 'hola.gif',
        '.hello3': 'hola.gif',
        '.menabria': 'menabria.gif',
        '.marshmallow': 'marshmallow.gif',
        '.hulkk': 'hulkk.gif',
        '.pop': 'pop.gif',
        '.clown': 'clown.gif',
        '.trex': 'trex.gif',
        '.nugget': 'nugget.gif',
        '.smartass': 'smartass.gif',
        '.notdingall': 'smartass.gif',
        '.ayleks': 'ayleks.gif',
        '.ayleks2': 'ayleks2.gif',
        '.deathuru': 'deathuru.gif',
        '.death': 'deathuru.gif',
        '.bonk': 'bonk.gif',
        '.rii': 'rii.gif',
        '.coelle': 'coelle.gif',
        '.coco': 'coelle.gif',
        '.hawk': 'hawk.gif',
        '.mz2': 'mz3.gif',
        '.selle1': 'selle1.gif',
        '.selle2': 'selle1.gif',
        '.emz': 'emz.gif',
        '.pp': 'pp.gif',
        '.wade4': 'wade4.gif',
        '.dr': 'dr.gif',
        '.luisa': 'luisa.gif',
        '.lis': 'lis.gif',
        '.dr1': 'dr1.gif',
        '.wolfy2': 'wolfy2.gif',
        '.rep': 'rep.gif',
        '.rep2': 'rep2.gif',
        '.rep3': 'rep3.gif',
        '.franz': 'franz.gif',
        '.anker': 'anker.gif',
        '.kat': 'kat.gif',
        '.prince': 'prince.gif',
        '.roxy': 'rox2.gif',
        '.marce': 'marce.gif',
        '.orphie': 'orphie2.gif',
        '.orph': 'orphie2.gif',
        '.orphelia': 'orphie2.gif',
        '.kevin2': 'kevin2.gif',
        '.steve': 'steve.gif',
        '.brunette': 'brunette.gif',
        '.igee': 'igee.gif',
        '.dexy': 'dex.gif',
        '.shady': 'shady2.gif',
        '.kei': 'kei.gif',
        '.lgr': 'lgr.gif',
        '.lead': 'lead.gif',
        '.rockchick': 'rockchick.gif',
        '.rockchick2': 'rockchick2.gif',
        '.dancingchicken': 'dancingchicken.gif',
        '.dancingchicken2': 'dancingchicken2.gif',
        '.rc': 'rockchick.gif',
        '.rc2': 'rockchick2.gif',
        '.dc': 'dancingchicken.gif',
        '.dc2': 'dancingchicken2.gif',
        '.rd': 'rockchick.gif',
        '.rd2': 'rockchick2.gif',
        '.dd': 'dancingchicken.gif',
        '.dd2': 'dancingchicken2.gif',
        '.loveslap': 'slap.gif',
        '.ls': 'slap.gif',
        '.monkey': 'monkey.gif',
        '.popcorn': 'popcorn.gif',
    },

    Skype: {
        '*)': 's/think.gif#32',
        '*-)': 's/think.gif#32',
        '*-:)': 's/idea.gif#32',
        '*-|': 's/punch.gif#32',
        '*:)': 's/idea.gif#32',
        '*|': 's/punch.gif#32',
        '+o(': 's/puke.gif#32',
        '8)': 's/cool.gif#32',
        '8-)': 's/cool.gif#32',
        '8-|': 's/nerdy.gif#32',
        '8=)': 's/cool.gif#32',
        '8=|': 's/nerdy.gif#32',
        '8|': 's/nerdy.gif#32',
        ':">': 's/blush.gif#32',
        ':#': 's/lipssealed.gif#32',
        ':&': 's/puke.gif#32',
        ':(|)': 's/monkey.gif#32',
        ':-#': 's/lipssealed.gif#32',
        ':-&': 's/puke.gif#32',
        ':-<': 's/sad.gif#32',
        ':->': 's/laugh.gif#32',
        ':-?': 's/think.gif#32',
        ':-@': 's/angry.gif#32',
        ':-]': 's/inlove.gif#32',
        ':-|': 's/speechless.gif#32',
        ':3': 's/cat.gif#32',
        ':<': 's/sad.gif#32',
        ':=#': 's/lipssealed.gif#32',
        ':=$': 's/blush.gif#32',
        ':=&': 's/puke.gif#32',
        ':=(': 's/sad.gif#32',
        ':=)': 's/smile.gif#32',
        ':=*': 's/kiss.gif#32',
        ':=?': 's/think.gif#32',
        ':=@': 's/angry.gif#32',
        ':=d': 's/laugh.gif#32',
        ':=o': 's/surprised.gif#32',
        ':=p': 's/tongueout.gif#32',
        ':=s': 's/worry.gif#32',
        ':=x': 's/lipssealed.gif#32',
        ':=|': 's/speechless.gif#32',
        ':>': 's/laugh.gif#32',
        ':?': 's/think.gif#32',
        ':@': 's/angry.gif#32',
        ':]': 's/inlove.gif#32',
        ':^)': 's/wonder.gif#32',
        ':i': 's/idea.gif#32',
        ':o3': 's/dog.gif#32',
        ':{': 's/movember.gif#32',
        ':|': 's/speechless.gif#32',
        ';-@': 's/angry.gif#32',
        ';=(': 's/cry.gif#32',
        ';=)': 's/wink.gif#32',
        ';@': 's/angry.gif#32',
        '<:o)': 's/party.gif#32',
        '<o)': 's/party.gif#32',
        '=ǝe=': 's/fistbump.gif#32',
        '@=': 's/bomb.gif#32',
        '\\:d/': 's/dance.gif#32',
        '\\o/': 's/dance.gif#32',
        ']:)': 's/evilgrin.gif#32',
        '_/\\_': 's/praying.gif#32',
        'b-|': 's/nerdy.gif#32',
        'b=)': 's/cool.gif#32',
        'b=|': 's/nerdy.gif#32',
        'b|': 's/nerdy.gif#32',
        'i)': 's/sleepy.gif#32',
        'i-)': 's/sleepy.gif#32',
        'i=)': 's/sleepy.gif#32',
        'p#d': 's/fistbump.gif#32',
        'x(': 's/angry.gif#32',
        'x-(': 's/angry.gif#32',
        'x=(': 's/angry.gif#32',
        '|(': 's/dull.gif#32',
        '|)': 's/sleepy.gif#32',
        '|-(': 's/dull.gif#32',
        '|-)': 's/sleepy.gif#32',
        '|=(': 's/dull.gif#32',
        ǝe: 's/fistbump.gif#32',
        '(!!)': 's/canyoutalk.gif#32',
        '(!!?)': 's/whatsgoingon.gif#32',
        '(!)': 's/stop.gif#32',
        '(#)': 's/sun.gif#32',
        '($)': 's/cash.gif#32',
        '(&)': 's/dog.gif#32',
        '(*)': 's/star.gif#32',
        '(0)': 's/time.gif#32',
        '(6)': 's/devil.gif#32',
        '(8)': 's/music.gif#32',
        '(:|': 's/sweat.gif#32',
        '(@)': 's/cat.gif#32',
        '(@h)': 's/wfh.gif#32',
        '(^)': 's/cake.gif#32',
        '(a)': 's/angel.gif#32',
        '(abe)': 's/abe.gif#32',
        '(abey)': 's/abe.gif#32',
        '(access)': 's/access.gif#32',
        '(aeroplane)': 's/plane.gif#32',
        '(aircraft)': 's/plane.gif#32',
        '(airplane)': 's/plane.gif#32',
        '(ancientone)': 's/ancientone.gif#32',
        '(angel)': 's/angel.gif#32',
        '(anger)': 's/anger.gif#32',
        '(angry)': 's/angry.gif#32',
        '(ap)': 's/plane.gif#32',
        '(ape)': 's/monkey.gif#32',
        '(au)': 's/car.gif#32',
        '(auld)': 's/auld.gif#32',
        '(b)': 's/beer.gif#32',
        '(bah)': 's/sheep.gif#32',
        '(bandit)': 's/bandit.gif#32',
        '(banghead)': 's/headbang.gif#32',
        '(bartlett)': 's/bertlett.gif#32',
        '(bear)': 's/hug.gif#32',
        '(beer)': 's/beer.gif#32',
        '(bell)': 's/bell.gif#32',
        '(berightback)': 's/brb.gif#32',
        '(bhangra)': 's/bhangra.gif#32',
        '(bicycle)': 's/bike.gif#32',
        '(bike)': 's/bike.gif#32',
        '(bing)': 's/bing.gif#32',
        '(bla)': 's/ttm.gif#32',
        '(blush)': 's/blush.gif#32',
        '(bollylove)': 's/bollylove.gif#32',
        '(bomb)': 's/bomb.gif#32',
        '(bow)': 's/bow.gif#32',
        '(bowled)': 's/bowled.gif#32',
        '(bowman)': 's/movember.gif#32',
        '(boy)': 's/man.gif#32',
        '(brb)': 's/brb.gif#32',
        '(bricklayers)': 's/beer.gif#32',
        '(brokenheart)': 's/brokenheart.gif#32',
        '(bronzemedal)': 's/bronzemedal.gif#32',
        '(bug)': 's/bug.gif#32',
        '(bunny)': 's/bunny.gif#32',
        '(busyday)': 's/busyday.gif#32',
        '(bye)': 's/hi.gif#32',
        '(c)': 's/coffee.gif#32',
        '(cake)': 's/cake.gif#32',
        '(calendar)': 's/letsmeet.gif#32',
        '(call)': 's/call.gif#32',
        '(camera)': 's/camera.gif#32',
        '(canyoutalk)': 's/canyoutalk.gif#32',
        '(car)': 's/car.gif#32',
        '(cash)': 's/cash.gif#32',
        '(cat)': 's/cat.gif#32',
        '(celebrate)': 's/handsinair.gif#32',
        '(celebration)': 's/handsinair.gif#32',
        '(chai)': 's/chai.gif#32',
        '(champagne)': 's/champagne.gif#32',
        '(chappal)': 's/chappal.gif#32',
        '(chauka)': 's/pullshot.gif#32',
        '(cheers)': 's/cheers.gif#32',
        '(cheese)': 's/cheese.gif#32',
        '(christmas)': 's/santa.gif#32',
        '(christmastree)': 's/xmastree.gif#32',
        '(chuckle)': 's/giggle.gif#32',
        '(ci)': 's/smoke.gif#32',
        '(clap)': 's/clap.gif#32',
        '(clock)': 's/time.gif#32',
        '(co)': 's/computer.gif#32',
        '(coffee)': 's/coffee.gif#32',
        '(cold)': 's/shivering.gif#32',
        '(computer)': 's/computer.gif#32',
        '(computerrage)': 's/computerrage.gif#32',
        '(confidential)': 's/confidential.gif#32',
        '(cool)': 's/cool.gif#32',
        '(crazychristmas)': 's/holidayspirit.gif#32',
        '(crazyxmas)': 's/holidayspirit.gif#32',
        '(crossedfingers)': 's/fingerscrossed.gif#32',
        '(cry)': 's/cry.gif#32',
        '(cryingwithlaughter)': 's/cwl.gif#32',
        '(cwl)': 's/cwl.gif#32',
        '(d)': 's/drink.gif#32',
        '(dance)': 's/dance.gif#32',
        '(dancingpenguin)': 's/penguin.gif#32',
        '(devil)': 's/devil.gif#32',
        '(dhakkan)': 's/dhakkan.gif#32',
        '(disco)': 's/discodancer.gif#32',
        '(discodancer)': 's/discodancer.gif#32',
        '(disgust)': 's/disgust.gif#32',
        '(diwali)': 's/diya.gif#32',
        '(diya)': 's/diya.gif#32',
        '(doctorstrange)': 's/doctorstrange.gif#32',
        '(dog)': 's/dog.gif#32',
        '(doh)': 's/doh.gif#32',
        '(donkey)': 's/donkey.gif#32',
        '(donttalk)': 's/donttalktome.gif#32',
        '(donttalktome)': 's/donttalktome.gif#32',
        '(donttalktote)': 's/donttalktome.gif#32',
        '(blegh)': 's/donttalktome.gif#32',
        '(dream)': 's/dream.gif#32',
        '(drink)': 's/drink.gif#32',
        '(drunk)': 's/drunk.gif#32',
        '(dull)': 's/dull.gif#32',
        '(e)': 's/mail.gif#32',
        '(eg)': 's/evilgrin.gif#32',
        '(ek)': 's/naturescall.gif#32',
        '(emo)': 's/emo.gif#32',
        '(engagement)': 's/ring.gif#32',
        '(envy)': 's/envy.gif#32',
        '(evil)': 's/evilgrin.gif#32',
        '(evilgrin)': 's/evilgrin.gif#32',
        '(excel)': 's/excel.gif#32',
        '(explode)': 's/bomb.gif#32',
        '(explosion)': 's/bomb.gif#32',
        '(f)': 's/flower.gif#32',
        '(facepalm)': 's/facepalm.gif#32',
        '(fail)': 's/facepalm.gif#32',
        '(fallinlove)': 's/fallinlove.gif#32',
        '(fatguy)': 's/muscleman.gif#32',
        '(fear)': 's/fear.gif#32',
        '(feetontable)': 's/neil.gif#32',
        '(female)': 's/woman.gif#32',
        '(festiveparty)': 's/festiveparty.gif#32',
        '(film)': 's/movie.gif#32',
        '(finger)': 's/finger.gif#32',
        '(fingers)': 's/fingerscrossed.gif#32',
        '(fingerscrossed)': 's/fingerscrossed.gif#32',
        '(fistbump)': 's/fistbump.gif#32',
        '(flex)': 's/muscle.gif#32',
        '(flower)': 's/flower.gif#32',
        '(fool)': 's/dhakkan.gif#32',
        '(football)': 's/bertlett.gif#32',
        '(footballfail)': 's/footballfail.gif#32',
        '(forever)': 's/waiting.gif#32',
        '(freezing)': 's/shivering.gif#32',
        '(g)': 's/gift.gif#32',
        '(gadha)': 's/donkey.gif#32',
        '(games)': 's/games.gif#32',
        '(ghanta)': 's/bell.gif#32',
        '(ghost)': 's/ghost.gif#32',
        '(gift)': 's/gift.gif#32',
        '(giggle)': 's/giggle.gif#32',
        '(girl)': 's/woman.gif#32',
        '(gl)': 's/goodluck.gif#32',
        '(goldmedal)': 's/goldmedal.gif#32',
        '(golmaal)': 's/golmaal.gif#32',
        '(goodluck)': 's/goodluck.gif#32',
        '(gottarun)': 's/gottarun.gif#32',
        '(gran)': 's/gran.gif#32',
        '(grin)': 's/evilgrin.gif#32',
        '(groupme)': 's/groupme.gif#32',
        '(gtr)': 's/gottarun.gif#32',
        '(h)': 's/heart.gif#32',
        '(h5)': 's/highfive.gif#32',
        '(halloween)': 's/pumpkin.gif#32',
        '(handshake)': 's/handshake.gif#32',
        '(handsinair)': 's/handsinair.gif#32',
        '(happy)': 's/happy.gif#32',
        '(headbang)': 's/headbang.gif#32',
        '(headphones)': 's/headphones.gif#32',
        '(heart)': 's/heart.gif#32',
        '(hearteyes)': 's/hearteyes.gif#32',
        '(heidy)': 's/heidy.gif#32',
        '(hero)': 's/hero.gif#32',
        '(hi)': 's/hi.gif#32',
        '(hia)': 's/handsinair.gif#32',
        '(hifive)': 's/highfive.gif#32',
        '(highfive)': 's/highfive.gif#32',
        '(holdon)': 's/holdon.gif#32',
        '(holi)': 's/holi.gif#32',
        '(holidayspirit)': 's/holidayspirit.gif#32',
        '(hrv)': 's/poolparty.gif#32',
        '(hug)': 's/hug.gif#32',
        '(hungover)': 's/hungover.gif#32',
        '(hungrycat)': 's/hungrycat.gif#32',
        '(idea)': 's/idea.gif#32',
        '(ie)': 's/internetexplorer.gif#32',
        '(ill)': 's/ill.gif#32',
        '(impatience)': 's/waiting.gif#32',
        '(inlove)': 's/inlove.gif#32',
        '(internetexplorer)': 's/internetexplorer.gif#32',
        '(ip)': 's/island.gif#32',
        '(island)': 's/island.gif#32',
        '(j)': 's/ninja.gif#32',
        '(jet)': 's/plane.gif#32',
        '(joy)': 's/joy.gif#32',
        '(k)': 's/kiss.gif#32',
        '(kaanpakadna)': 's/kaanpakadna.gif#32',
        '(kaecilius)': 's/kaecilius.gif#32',
        '(karlmordo)': 's/karlmordo.gif#32',
        '(kasamse)': 's/promise.gif#32',
        '(kate)': 's/makeup.gif#32',
        '(key)': 's/key.gif#32',
        '(kiss)': 's/kiss.gif#32',
        '(kitty)': 's/cat.gif#32',
        '(kya)': 's/kya.gif#32',
        '(l)': 's/heart.gif#32',
        '(laddu)': 's/laddu.gif#32',
        '(ladyvamp)': 's/ladyvampire.gif#32',
        '(ladyvampire)': 's/ladyvampire.gif#32',
        '(lala)': 's/lalala.gif#32',
        '(lalala)': 's/lalala.gif#32',
        '(lalalala)': 's/lalala.gif#32',
        '(lang)': 's/lang.gif#32',
        '(laugh)': 's/laugh.gif#32',
        '(learn)': 's/learn.gif#32',
        '(letsmeet)': 's/letsmeet.gif#32',
        '(lfcclap)': 's/lfcclap.gif#32',
        '(lfcfacepalm)': 's/lfcfacepalm.gif#32',
        '(lfclaugh)': 's/lfclaugh.gif#32',
        '(lfcparty)': 's/lfcparty.gif#32',
        '(lfcworried)': 's/lfcworried.gif#32',
        '(like)': 's/like.gif#32',
        '(linux)': 's/penguin.gif#32',
        '(lips)': 's/lips.gif#32',
        '(lipssealed)': 's/lipssealed.gif#32',
        '(listening)': 's/listening.gif#32',
        '(llsshock)': 's/llsshock.gif#32',
        '(lol)': 's/laugh.gif#32',
        '(london)': 's/rain.gif#32',
        '(love)': 's/inlove.gif#32',
        '(lovebunny)': 's/bunny.gif#32',
        '(m)': 's/mail.gif#32',
        '(maafi)': 's/kaanpakadna.gif#32',
        '(mail)': 's/mail.gif#32',
        '(makeup)': 's/makeup.gif#32',
        '(male)': 's/man.gif#32',
        '(malthe)': 's/mlt.gif#32',
        '(man)': 's/man.gif#32',
        '(meow)': 's/cat.gif#32',
        '(microsoft)': 's/microsoft.gif#32',
        '(mistletoe)': 's/mistletoe.gif#32',
        '(mlt)': 's/mlt.gif#32',
        '(mm)': 's/mmm.gif#32',
        '(mmm)': 's/mmm.gif#32',
        '(mmmm)': 's/mmm.gif#32',
        '(mo)': 's/cash.gif#32',
        '(monkey)': 's/monkey.gif#32',
        '(monkeygiggle)': 's/monkeygiggle.gif#32',
        '(monkeyyear)': 's/yotm.gif#32',
        '(mooning)': 's/mooning.gif#32',
        '(mooningsanta)': 's/santamooning.gif#32',
        '(morningafter)': 's/hungover.gif#32',
        '(moustache)': 's/movember.gif#32',
        '(movember)': 's/movember.gif#32',
        '(movie)': 's/movie.gif#32',
        '(movinghome)': 's/movinghome.gif#32',
        '(mp)': 's/phone.gif#32',
        '(ms)': 's/microsoft.gif#32',
        '(muscle)': 's/muscle.gif#32',
        '(muscleman)': 's/muscleman.gif#32',
        '(music)': 's/music.gif#32',
        '(mustache)': 's/movember.gif#32',
        '(n)': 's/no.gif#32',
        '(naa)': 's/nahi.gif#32',
        '(nahi)': 's/nahi.gif#32',
        '(namaste)': 's/praying.gif#32',
        '(naturescall)': 's/naturescall.gif#32',
        '(nazar)': 's/nazar.gif#32',
        '(neil)': 's/neil.gif#32',
        '(nerd)': 's/nerdy.gif#32',
        '(nerdy)': 's/nerdy.gif#32',
        '(ninja)': 's/ninja.gif#32',
        '(ninjacat)': 's/win10.gif#32',
        '(no)': 's/no.gif#32',
        '(nod)': 's/nod.gif#32',
        '(notlistening)': 's/lalala.gif#32',
        '(november)': 's/movember.gif#32',
        '(nr2)': 's/ontheloo.gif#32',
        '(nudge)': 's/poke.gif#32',
        '(o)': 's/time.gif#32',
        '(ok)': 's/ok.gif#32',
        '(okay)': 's/ok.gif#32',
        '(oliver)': 's/oliver.gif#32',
        '(onedrive)': 's/onedrive.gif#32',
        '(onenote)': 's/onenote.gif#32',
        '(onloo)': 's/ontheloo.gif#32',
        '(ontheloo)': 's/ontheloo.gif#32',
        '(out)': 's/bowled.gif#32',
        '(outlook)': 's/outlook.gif#32',
        '(oye)': 's/oye.gif#32',
        '(p)': 's/camera.gif#32',
        '(party)': 's/party.gif#32',
        '(partyxmas)': 's/festiveparty.gif#32',
        '(pc)': 's/computer.gif#32',
        '(penguin)': 's/penguin.gif#32',
        '(penguindance)': 's/penguin.gif#32',
        '(penguinkiss)': 's/penguinkiss.gif#32',
        '(ph)': 's/phone.gif#32',
        '(phew)': 's/whew.gif#32',
        '(phone)': 's/phone.gif#32',
        '(pi)': 's/pizza.gif#32',
        '(pig)': 's/pig.gif#32',
        '(piggybank)': 's/piggybank.gif#32',
        '(pizza)': 's/pizza.gif#32',
        '(plane)': 's/plane.gif#32',
        '(play)': 's/games.gif#32',
        '(playbox)': 's/games.gif#32',
        '(ply)': 's/games.gif#32',
        '(poke)': 's/poke.gif#32',
        '(polarbear)': 's/polarbear.gif#32',
        '(polarbearhug)': 's/polarbear.gif#32',
        '(poolparty)': 's/poolparty.gif#32',
        '(poop)': 's/poop.gif#32',
        '(powerpoint)': 's/powerpoint.gif#32',
        '(pray)': 's/praying.gif#32',
        '(praying)': 's/praying.gif#32',
        '(priidu)': 's/priidu.gif#32',
        '(promise)': 's/promise.gif#32',
        '(publisher)': 's/publisher.gif#32',
        '(puke)': 's/puke.gif#32',
        '(pullshot)': 's/pullshot.gif#32',
        '(pumpkin)': 's/pumpkin.gif#32',
        '(punch)': 's/punch.gif#32',
        '(qt)': 's/confidential.gif#32',
        '(r)': 's/rainbow.gif#32',
        '(rabbit)': 's/bunny.gif#32',
        '(rain)': 's/rain.gif#32',
        '(rainbow)': 's/rainbow.gif#32',
        '(rang)': 's/holi.gif#32',
        '(red)': 's/red.gif#32',
        '(reindeer)': 's/reindeer.gif#32',
        '(ricksha)': 's/rickshaw.gif#32',
        '(rickshaw)': 's/rickshaw.gif#32',
        '(rikshaw)': 's/rickshaw.gif#32',
        '(ring)': 's/ring.gif#32',
        '(rock)': 's/rock.gif#32',
        '(rofl)': 's/rofl.gif#32',
        '(rotfl)': 's/rofl.gif#32',
        '(run)': 's/gottarun.gif#32',
        '(running)': 's/running.gif#32',
        '(s+)': 's/letsmeet.gif#32',
        '(sad)': 's/sad.gif#32',
        '(sadness)': 's/sadness.gif#32',
        '(sander)': 's/bike.gif#32',
        '(santa)': 's/santa.gif#32',
        '(santamooning)': 's/santamooning.gif#32',
        '(sarcasm)': 's/sarcastic.gif#32',
        '(sarcastic)': 's/sarcastic.gif#32',
        '(seeti)': 's/whistle.gif#32',
        '(selfie)': 's/selfie.gif#32',
        '(sforb)': 's/skypebiz.gif#32',
        '(shake)': 's/shake.gif#32',
        '(sharepoint)': 's/sharepoint.gif#32',
        '(sheep)': 's/sheep.gif#32',
        '(shivering)': 's/shivering.gif#32',
        '(shock)': 's/shock.gif#32',
        '(shopper)': 's/shopping.gif#32',
        '(shopping)': 's/shopping.gif#32',
        '(shot)': 's/pullshot.gif#32',
        '(silvermedal)': 's/silvermedal.gif#32',
        '(skip)': 's/skip.gif#32',
        '(skipping)': 's/skipping.gif#32',
        '(skippingrope)': 's/skip.gif#32',
        '(skull)': 's/skull.gif#32',
        '(skype)': 's/skype.gif#32',
        '(skypebiz)': 's/skypebiz.gif#32',
        '(slamdunk)': 's/slamdunk.gif#32',
        '(slap)': 's/slap.gif#32',
        '(sleepy)': 's/sleepy.gif#32',
        '(slipper)': 's/chappal.gif#32',
        '(sloth)': 's/sloth.gif#32',
        '(slowclap)': 's/sarcastic.gif#32',
        '(smile)': 's/smile.gif#32',
        '(smirk)': 's/smirk.gif#32',
        '(smoke)': 's/smoke.gif#32',
        '(smoking)': 's/smoke.gif#32',
        '(sn)': 's/snail.gif#32',
        '(snail)': 's/snail.gif#32',
        '(snooze)': 's/sleepy.gif#32',
        '(snowangel)': 's/snowangel.gif#32',
        '(snowflake)': 's/snowflake.gif#32',
        '(so)': 's/bertlett.gif#32',
        '(soccer)': 's/bertlett.gif#32',
        '(sorry)': 's/kaanpakadna.gif#32',
        '(sparkling)': 's/champagne.gif#32',
        '(speechless)': 's/speechless.gif#32',
        '(squirrel)': 's/heidy.gif#32',
        '(ss)': 's/skype.gif#32',
        '(st)': 's/rain.gif#32',
        '(star)': 's/star.gif#32',
        '(stink)': 's/cheese.gif#32',
        '(stop)': 's/stop.gif#32',
        '(success)': 's/key.gif#32',
        '(sun)': 's/sun.gif#32',
        '(surprised)': 's/surprised.gif#32',
        '(suryannamaskar)': 's/suryannamaskar.gif#32',
        '(swear)': 's/swear.gif#32',
        '(sweat)': 's/sweat.gif#32',
        '(synchswim)': 's/synchswim.gif#32',
        '(syne)': 's/syne.gif#32',
        '(t)': 's/call.gif#32',
        '(talk)': 's/talk.gif#32',
        '(talktothehand)': 's/talktothehand.gif#32',
        '(tandoori)': 's/tandoorichicken.gif#32',
        '(tandoorichicken)': 's/tandoorichicken.gif#32',
        '(target)': 's/target.gif#32',
        '(taur)': 's/taur.gif#32',
        '(tauri)': 's/taur.gif#32',
        '(tea)': 's/chai.gif#32',
        '(tennisfail)': 's/tennisfail.gif#32',
        '(thanks)': 's/thanks.gif#32',
        '(thanksgiving)': 's/turkey.gif#32',
        '(thappad)': 's/slap.gif#32',
        '(think)': 's/think.gif#32',
        '(time)': 's/time.gif#32',
        '(tired)': 's/tired.gif#32',
        '(tmi)': 's/tmi.gif#32',
        '(toivo)': 's/toivo.gif#32',
        '(tongue)': 's/tongueout.gif#32',
        '(tongueout)': 's/tongueout.gif#32',
        '(trampoline)': 's/trampoline.gif#32',
        '(trex)': 's/win10.gif#32',
        '(trophy)': 's/trophy.gif#32',
        '(ttm)': 's/ttm.gif#32',
        '(tubelight)': 's/tubelight.gif#32',
        '(tumbleweed)': 's/tumbleweed.gif#32',
        '(turkey)': 's/turkey.gif#32',
        '(turkeydance)': 's/turkey.gif#32',
        '(tvbinge)': 's/tvbinge.gif#32',
        '(twittering)': 's/ontheloo.gif#32',
        '(typingrage)': 's/computerrage.gif#32',
        '(u)': 's/brokenheart.gif#32',
        '(um)': 's/umbrella.gif#32',
        '(umbrella)': 's/umbrella.gif#32',
        '(unamused)': 's/unamused.gif#32',
        '(unsee)': 's/unsee.gif#32',
        '(v)': 's/envy.gif#32',
        '(vampire)': 's/vampire.gif#32',
        '(verybusy)': 's/ontheloo.gif#32',
        '(victory)': 's/victory.gif#32',
        '(w8)': 's/holdon.gif#32',
        '(wait)': 's/wait.gif#32',
        '(waiting)': 's/waiting.gif#32',
        '(wasntme)': 's/wasntme.gif#32',
        '(wave)': 's/hi.gif#32',
        '(wfh)': 's/wfh.gif#32',
        '(whatsgoingon)': 's/whatsgoingon.gif#32',
        '(whew)': 's/whew.gif#32',
        '(whistle)': 's/whistle.gif#32',
        '(whosthis)': 's/whosthis.gif#32',
        '(wicket)': 's/bowled.gif#32',
        '(win10)': 's/win10.gif#32',
        '(windows)': 's/win10.gif#32',
        '(windows10)': 's/win10.gif#32',
        '(wink)': 's/wink.gif#32',
        '(winner)': 's/winner.gif#32',
        '(wm)': 's/wasntme.gif#32',
        '(woman)': 's/woman.gif#32',
        '(wonder)': 's/wonder.gif#32',
        '(wong)': 's/wong.gif#32',
        '(word)': 's/word.gif#32',
        '(worried)': 's/worry.gif#32',
        '(worry)': 's/worry.gif#32',
        '(wtf)': 's/wtf.gif#32',
        '(x)': 's/angry.gif#32',
        '(xbox)': 's/xbox.gif#32',
        '(xmas)': 's/santa.gif#32',
        '(xmastree)': 's/xmastree.gif#32',
        '(xo)': 's/kiss.gif#32',
        '(y)': 's/yes.gif#32',
        '(yawn)': 's/yawn.gif#32',
        '(yes)': 's/yes.gif#32',
        '(yn)': 's/fingerscrossed.gif#32',
        '(yoga)': 's/yoga.gif#32',
        '(yotfr)': 's/yotfr.gif#32',
        '(yotm)': 's/yotm.gif#32',
        '(z)': 's/man.gif#32',
        '(zilmer)': 's/priidu.gif#32',
        '(~)': 's/movie.gif#32',
    },
}

Utils.prototype.emojies_keys = Object.keys(Utils.prototype.emojies)